import React, {useEffect, useRef, useState} from 'react'
import axios from 'axios'
import Cookies from 'js-cookie'

import * as constants from 'constants/index.js'
import CardsHeader from 'layouts/Headers/CardsHeader.js'

import InputCustom from 'views/pages/components/InputCustom'
import TableCustom from 'views/pages/components/TableCustom'

import {Card, CardBody, CardHeader, Col, Container, Modal, Row,} from 'reactstrap'
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import IconSet from "@assets/selection.json";
import IcoMoon from "react-icomoon";
import notify from '@utils/notify';

export default function Testimonials() {
  const [token, setToken] = useState('')
  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState([])

  const [item, setItem] = useState('')
  const [itemModal, setItemModal] = useState({
    show: false,
    header: '',
    division: ''
  })

  const [deleteModal, setDeleteModal] = useState({
    show: false,
    header: '',
    body: '',
    onClick: null,
  })
  
  const [errors, setErrors] = useState('')

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_URL}/pages/testimonial`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        console.log('response :: ', response.data)
        const data = response.data
        setItems(data.data.items)
        setLoading(false)
      } catch (error) {
        setLoading(false)
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify.warning(error.response.data.message ? error.response.data.message : error.response.statusText)
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])

  const createItem = async () => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${constants.API_URL}/pages/testimonial`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: item,
      })
      console.log('response :: ', response.data)
      const data = response.data
      setItems(data.data.items)
      notify.success(data.message)
      setItemModal({
        show: false
      })
    } catch (error) {
      console.error('error :: ', error)
      if (error.response && error.response.status === 422) {
        setErrors(error.response.data.errors)
        return
      }
      setItemModal({
        show: false
      })
      notify.warning(error.response.data.message ? error.response.data.message : error.response.statusText)
    }
  }

  const updateItem = async () => {
    try {
      const response = await axios({
        method: 'PUT',
        url: `${constants.API_URL}/pages/testimonial/${item.id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: item,
      })
      console.log('response :: ', response.data)
      const data = response.data
      setItems(data.data.items)
      notify.success(data.message)
      setItemModal({
        show: false
      })
    } catch (error) {
      console.error('error :: ', error)
      if (error.response && error.response.status === 422) {
        setErrors(error.response.data.errors)
        return
      }
      setItemModal({
        show: false
      })
      notify.warning(error.response.data.message ? error.response.data.message : error.response.statusText)
    }
  }

  const deleteItem = async (id) => {
    try {
      const response = await axios({
        method: 'DELETE',
        url: `${constants.API_URL}/pages/testimonial/${id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      console.log('response :: ', response.data)
      const data = response.data
      setItems(data.data.items)
      notify.success(data.message)
      setDeleteModal({
        show: false
      })
    } catch (error) {
      console.error('error :: ', error)
      setDeleteModal({
        show: false
      })
      notify.warning(error.response.data.message ? error.response.data.message : error.response.statusText)
    }
  }

  return (
    <>
      <CardsHeader name="Testiomnials" parentName="Testimonial Management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={8}>
                    <h1 className="mb-0">Testimonials</h1>
                    <p className="text-sm mb-0">Testimonial management</p>
                  </Col>
                  <Col xs={4} className="text-right">
                    <ButtonContainer  onClick={() => {
                      setItem('')
                      setErrors('')
                      setItemModal({
                        ...itemModal,
                        show: true,
                        header: 'Add a new testimonial',
                        division: 'create'
                      })
                    }}>
                      <i className="fa fa-plus" aria-hidden="true"></i>
                      Add new
                    </ButtonContainer>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <TableCustom 
                  loading={loading}
                  items={items}
                  columns={[
                    {
                      dataField: "title",
                      text: "Title"
                    },
                    {
                      dataField: "content",
                      text: "URL"
                    },
                    {
                      dataField: "updated_at",
                      text: "Updated At",
                      formatter: (rowContent, row) => {
                        return row.updated_at? constants.formatDateShortGB(row.updated_at): ''
                      }
                    },
                    {
                      dataField: "",
                      text: "Action",
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            <IcoMoon
                                className={'cursor-pointer'}
                                iconSet={IconSet}
                                icon={'edit'}
                                size={24}
                                onClick={() => {
                                  setItem(row)
                                  setErrors('')
                                  setItemModal({
                                    ...itemModal,
                                    show: true,
                                    header: 'Update testimonial',
                                    division: 'update',
                                  })
                                }}
                            />
                            <IcoMoon
                                className={'cursor-pointer'}
                                iconSet={IconSet}
                                icon={'delete_outline'}
                                size={24}
                                onClick={() => {
                                  setDeleteModal({
                                    ...deleteModal,
                                    show: true,
                                    header: 'Delete testimonial',
                                    body: 'Are you sure you want to delete this testimonial?',
                                    onClick: () => deleteItem(row.id)
                                  })
                                }}
                            />
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={itemModal.show}
          toggle={() => setItemModal({
            ...itemModal,
            show: false,
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title main-color">{itemModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setItemModal({
                ...itemModal,
                show: false,
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <InputCustom 
              newLabel={`URL`}
              value={item && item.content? item.content: ''}
              onChange={e => setItem({
                ...item,
                content: e.target.value,
              })}
              invalid={errors && errors.content? true: false}
              errorMessage={errors.content}
            />
            <InputCustom 
              newLabel={`Title`}
              value={item && item.title? item.title: ''}
              onChange={e => setItem({
                ...item,
                title: e.target.value,
              })}
              invalid={errors && errors.title? true: false}
              errorMessage={errors.title}
            />
          </div>
          <div className="modal-footer justify-content-end">
            <ButtonContainer
                onClick={() => setItemModal({
                  ...itemModal,
                  show: false,
                })}
            >
              {`Close`}
            </ButtonContainer>
            <ButtonContainer
              reverse
              onClick={() => itemModal.division === 'create'? createItem() : updateItem()}
            >
              {`Save`}
            </ButtonContainer>

          </div>
        </Modal>
        <Modal
          isOpen={deleteModal.show}
          toggle={() => setDeleteModal({
            ...deleteModal,
            show: false,
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title main-color">{deleteModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false,
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            {deleteModal.body}
          </div>
          <div className="modal-footer justify-content-end">
            <ButtonContainer
                onClick={() => setDeleteModal({
                  ...deleteModal,
                  show: false,
                })}
            >
              {`Close`}
            </ButtonContainer>
            <ButtonContainer
              reverse
              onClick={deleteModal.onClick}
            >
              {`Delete`}
            </ButtonContainer>

          </div>
        </Modal>
      </Container>
    </>
  )
}